module.exports = __webpack_public_path__ + "dc54a5699a1740d387f42e5854c71c15.woff";